import React from 'react';
import {Observer} from "mobx-react-lite";
import {useCommonContext} from "../../../contexts/CommonContext";
import ShowOrderStatus from "../ShowOrderStatus/ShowOrderStatus";
import ShowDate from "../ShowDate/ShowDate";
import PersonIcon from '@mui/icons-material/Person';
import { useUserContext } from '../../../contexts/UserContext';
import ShowProductOrderTimelineProperties from './ShowProductOrderTimelineProperties';
import { useStyles } from './ShowProductOrderTimeline.style';
import ShowProductOrderTimelineStore from './ShowProductOrderTimelineStore';
import AllowAccess from '../../Access/AllowAccess/AllowAccess';
import Access from '../../Access/AllowAccess/Access';
import ShowTraceType from '../ShowTraceType/ShowTraceType';

const ShowProductOrderTimeline: React.FC<ShowProductOrderTimelineProperties> = ({
                                                                                                  className = '',
                                                                                                  productOrderId,
                                                                                              }) => {
    const classes = useStyles();

    const commonContext = useCommonContext();
    const userStore = useUserContext();

    const hasTraceAccess = userStore.hasAccess(Access.LIST_PRODUCT_ORDERS_TRACES.valueOf());

    const store = new ShowProductOrderTimelineStore(commonContext, productOrderId, userStore.isRootAgency(), hasTraceAccess);
    
    return <Observer>
        {() => (
            <>
                <div className={classes.history_container}>
                    <div className={classes.body}>
                        {!store.isEmpty &&
                            <div className={classes.history_table}>
                                <div className={classes.line}/>
                                    {store.timelineItems.map((s, i) => (
                                            <div className={classes.element_row} key={i}>
                                                <div className={classes.date_container}>
                                                    <ShowDate timestamp={s.date} showSeconds />
                                                </div>
                                                <div className={classes.dot} />
                                                <div className={classes.element_container}>
                                                    {s.type === 'STATUS' && (() => {
                                                        const current = store.statusHistory.find(x => x.id === s.id);
                                                        return <ShowOrderStatus status={current?.status} />;
                                                    })()}
                                                    {s.type === 'TRACE' && (() => {
                                                        const current = store.traces.find(x => x.id === s.id);
                                                        return <ShowTraceType traceType={current?.type} />;
                                                    })()}
                                                    <div className={classes.comment}>{s.subTitle}</div>
                                                    <AllowAccess any={[Access.SHOW_USER_IN_STATUS_HISTORY]}>
                                                        {s.userName && (
                                                            <div className={classes.user_container}>
                                                                <PersonIcon fontSize="small" /> {s.userName}
                                                            </div>
                                                        )}
                                                    </AllowAccess>
                                                </div>
                                            </div>
                                        )
                                    )}
                            </div>
                        }
                    </div>
                </div>
            </>
        )}
    </Observer>
}

export default ShowProductOrderTimeline;
